<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-finance</v-icon>
                <span class="title font-weight-light">Configuração do Balancete Financeiro</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-form id="form" ref="form" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" sm="4" md="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataInicio" label="Data de Início" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataInicio" no-title/>
                            </v-menu>
                        </v-col>   
                        <v-col cols="12" sm="4" md="5">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="filtro.dataFim" label="Data de Fim" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="filtro.dataFim" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="2">
                            <v-switch style="margin-top: 5px" v-model="filtro.lista" label="Listagem" dense/>
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete :disabled="filtro.lista" v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                                item-text="codigoNome" item-value="id" label="Projeto" dense outlined/>
                        </v-col>           
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { ProjetoService } from '../../../core/services/projetos';

export default {
    watch: { 
        
    },
    data: () => ({
        filtro: {            
            dataInicio: null,            
            dataFim: null,
            projetoId: null,
            lista: false
        },
        valid: true,
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        isProjetoLoading: false,
        searchProjeto: null,
        projetoService: new ProjetoService(),
        projetos: []

    }),
    watch: {
        searchProjeto (val) {
            if (this.filtro.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        },
    },
    methods: {
        GerarRelatorio(){
            if (this.$refs.form.validate()) {
                this.AbrirJanela('relatorioBalanceteFinanceiro')
            }
        },
        LimparFiltros(){
            this.filtro = {
                dataInicio: null,            
                dataFim: null,
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    dataInicio: this.filtro.dataInicio,
                    dataFim: this.filtro.dataFim,
                    projetoId: this.filtro.projetoId,
                    lista: this.filtro.lista
                } 
            });
            window.open(routeLink.href,'_blank');
        },
    },
    mounted(){
        if('form' in this.$refs)
            this.$refs.form.resetValidation();
    }
}

</script>